import { Injectable } from '@angular/core';
import {
  applyClientTheme,
  applyDefaultColourTheme,
} from '@core/constants/theme.const';
import { AirConfigType } from '@core/layouts/types/user-profile.type';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { GetClientLogoApiResponseType } from '../../shared/types';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  mainBrandingLogo = new BehaviorSubject<string>(
    '/assets/images/flydocs-logo.svg',
  );
  currentStatusBrandingLogo = new BehaviorSubject(
    '/assets/images/flydocs-logo.svg',
  );
  themeData!: AirConfigType;
  $themeSubject = new Subject<AirConfigType>();
  $subscription = new Subscription();
  $reloadTab = new Subject<boolean>();

  initThemeLogo(data: GetClientLogoApiResponseType) {
    if (data.currentStatusBrandingLogoSignedUrl)
      this.currentStatusBrandingLogo.next(
        data.currentStatusBrandingLogoSignedUrl,
      );
    else this.currentStatusBrandingLogo.next('/assets/images/flydocs-logo.svg');
    if (data.mainBrandingLogoSignedUrl)
      this.mainBrandingLogo.next(data.mainBrandingLogoSignedUrl);
    else this.mainBrandingLogo.next('/assets/images/flydocs-logo.svg');
  }

  initDefaultEmptyLogo(defaultLogo = false) {
    if (defaultLogo) {
      this.currentStatusBrandingLogo.next('/assets/images/flydocs-logo.svg');
      this.mainBrandingLogo.next('/assets/images/flydocs-logo.svg');
    } else {
      this.currentStatusBrandingLogo.next('');
      this.mainBrandingLogo.next('');
    }
  }

  setThemeData(data: AirConfigType, clientId: string) {
    /** Init Theme Data  */
    this.themeData = data;

    /** Check if client id is changed */
    const previousClientId = localStorage.getItem('client-id');

    let isClientIdChanged = false;

    if (previousClientId !== clientId) isClientIdChanged = true;

    /** Set Client Id if it is changed */
    if (isClientIdChanged) {
      localStorage.removeItem('client-id');
      localStorage.setItem('client-id', clientId);
    }

    if (this.themeData) {
      applyClientTheme(data, this.$reloadTab, isClientIdChanged);
    }
  }

  setDefaultTheme() {
    localStorage.removeItem('client-id');

    this.mainBrandingLogo.next('/assets/images/flydocs-logo.svg');
    this.currentStatusBrandingLogo.next('/assets/images/flydocs-logo.svg');
    applyDefaultColourTheme(this.themeData, this.$reloadTab);
  }
}
